import { render } from "./SendNotification.vue?vue&type=template&id=0d2afeff&scoped=true"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"

import "./SendNotification.vue?vue&type=style&index=0&id=0d2afeff&scoped=true&lang=css"
import "./SendNotification.vue?vue&type=style&index=1&id=0d2afeff&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2afeff"]])

export default __exports__